var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_253)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4483 59.3086C65.4361 62.1738 61.4124 64.5442 58.2036 65.2374C56.007 65.7037 53.1426 66.0727 43.491 62.073C32.6508 57.5819 17.598 41.5841 17.598 30.9381C17.598 25.5184 20.7228 19.2076 26.187 19.2076C28.8162 19.2076 29.3958 19.2589 30.261 21.3343C31.2732 23.7794 33.7428 29.8037 34.0368 30.4213C35.2506 32.9546 32.802 34.4377 31.0254 36.6434C30.4584 37.3071 29.8158 38.025 30.534 39.2602C31.248 40.4701 33.7176 44.495 37.3464 47.7258C42.0336 51.9018 45.8346 53.2351 47.1954 53.8022C48.2076 54.2224 49.4172 54.1245 50.1564 53.3347C51.093 52.3222 52.2564 50.6423 53.4408 48.987C54.2766 47.8022 55.3392 47.6543 56.4522 48.0744C57.204 48.3349 66.759 52.7723 67.1622 53.4823C67.4604 53.9991 67.4605 56.4433 66.4483 59.3086ZM42.0084 0H41.9874C18.8328 0 0 18.8385 0 42C0 51.184 2.96103 59.7044 7.99683 66.6155L2.76362 82.222L18.9042 77.0643C25.5444 81.4588 33.4698 84 42.0084 84C65.163 84 84 65.1615 84 42C84 18.8385 65.163 0 42.0084 0Z",
    fill: "#33A080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.8b2efc7bd5e82cddb80b72544dc2da19.svg";
export { ForwardRef as ReactComponent };